













































































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class SjkQuestionTable extends Vue {
  @Prop()
  private questions;
  @Prop()
  private filters;
  @Prop()
  private state: any;
  private selectChange(value, row) {
    this.$emit("selectChange", value, row);
  }
  /**
   * @description 单个添加
   */
  private addOne(question) {
    this.$emit("addOne", question);
  }
  /**
   * @description 开始分数
   */
  private startChangeFenshu(question) {
    question["isChangingFenshu"] = true;
  }
  /**
   * @description 修改分数
   */
  private changeFenshu(o, question) {
    this.$emit("changeFenshu", o, question);
  }
  /**
   * @description 删除一个题目
   */
  private deleteThis(question) {
    this.$emit("deleteOne", question);
  }
}
